import { NgModule } from '@angular/core';
import { IncludesPipe } from './includes.pipe';


@NgModule({
    imports: [],
    exports: [IncludesPipe,],
    declarations: [IncludesPipe,],
    providers: [],
})
export class IncludesPipeModule { }
